import React from 'react';
import PropTypes from 'prop-types';

import { useParams } from 'react-router-dom';
import { connect as reduxConnect } from 'react-redux';
import { actions } from '#redux/reducers';
import { roAPI } from '#utils/axiosAPI';
import styles from './formChangePassword.module.css';
import { Input } from '../../UI/input/input';
import { Controller, useForm } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '../../UI/form/form';

const FormChangePassword = ({ onAfterSubmit, alert }) => {
  const { email, code } = useParams();
  const form = useForm({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
    mode: 'onChange',
  });

  const handleFormSubmit = async data => {
    try {
      await roAPI.post('/auth/change/password/email', {
        email: decodeURIComponent(email),
        code: decodeURIComponent(code),
        password: data.password,
      });
      onAfterSubmit('/auth/inicio', 'redirect');
      alert({
        type: 'success',
        title: '¡Cambio de contraseña exitoso!',
        message: 'Por favor inicia sesión con tú nueva contraseña.',
      });
    } catch (error) {
      // handle error if needed
    }
  };

  return (
    <div data-testid="FormLogin">
      <form className={styles.form} onSubmit={form.handleSubmit(handleFormSubmit)} id="formLogin">
        <div className={styles['field-group']}>
          <Controller
            control={form.control}
            name="password"
            rules={{
              required: {
                value: true,
                message: 'La contraseña es obligatoria.',
              },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="password">
                  Contraseña
                </FieldLabel>
                <Input
                  {...field}
                  id="password"
                  aria-invalid={fieldState.invalid}
                  type="password"
                  placeholder="Contraseña"
                  autoComplete="new-password"
                />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <Controller
            control={form.control}
            name="confirmPassword"
            rules={{
              required: {
                value: true,
                message: 'La confirmación de contraseña es obligatoria.',
              },
              validate: value => value === form.getValues('password') || 'La contraseña no coincide.',
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="password2">
                  Confirmar contraseña
                </FieldLabel>
                <Input
                  {...field}
                  id="confirmPassword"
                  aria-invalid={fieldState.invalid}
                  type="password"
                  placeholder="Confirmar contraseña"
                  autoComplete="new-password"
                />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />
        </div>

        <button type="submit" className={`btn btn-une ${styles['btn-submit']}`}>
          Cambiar contraseña
        </button>
      </form>
    </div>
  );
};

FormChangePassword.propTypes = {
  onAfterSubmit: PropTypes.func,
  alert: PropTypes.func,
};

FormChangePassword.defaultProps = {
  onAfterSubmit: f => f,
  alert: f => f,
};

export default reduxConnect(
  () => ({}),
  dispatch => ({
    alert: alert => dispatch(actions.alert(alert)),
  }),
)(FormChangePassword);
